
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terminosycondiciones-alianzas",
      function () {
        return require("private-next-pages/terminosycondiciones-alianzas/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terminosycondiciones-alianzas"])
      });
    }
  